import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import JustificationModal from '@components/JustificationModal';

import { getBusiness, updateStatus } from '@actions/business';
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { StatusConst } from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import { getValueLanguageObj } from '@utils/general'

class Business extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loadingTable: true,
      allbusiness: [],
      business: [],
      findText: '',
      typeCountry: '',
      totalRecords: 0,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      lazyParams: {
        first: 0,
        rows: 6,
        page: 0,
      }
    };
  }

  componentDidMount() {
    this.loadData();
    return this.setState({loadingPage: false})
  }

  loadData = async () => {
    const { getBusiness } = this.props;
    const { lazyParams, findText, typeCountry } = this.state;
    this.setState({ loadingTable: true });
    // const params = {
    //   page: lazyParams.page,
    //   rows: lazyParams.rows,
    // };
    const params = {
      type: 'all'
    };

    if (findText) params.find = findText;
    if (typeCountry) params.country = typeCountry.id;

    const response = await getBusiness(params);
    if (!response?.status) {
      return this.setState({
        totalRecords: response?.data?.length || 0,
        allbusiness: response?.data,
        business: response?.data,
        loadingTable: false,
        lazyParams: { ...lazyParams, first: 0, page: 0 }
      });
    }
    return this.setState({ loadingTable: false });
  };

  loadDataByPage = () => {
    const { lazyParams, allbusiness } = this.state
    const dataPage = allbusiness.slice(lazyParams.first, (lazyParams.first + lazyParams.rows))
    this.setState({ business: dataPage })
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onPage', event);
    this.setState({ lazyParams: _lazyParams }, this.loadDataByPage);
  };

  onChange = ({target}) => {
    console.log('this.onChange', target)
    this.setState({[target.name]: target.value});
  };

  onChangeSearch = (e) => {
    this.setState({
       [e.target.name]: e.value ,
    });
  };

  onConfirmChangeStatus = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => this.onChangeStatusCompany(data, justification),
      },
    });
  }

  onChangeStatusCompany = async (data, justification) => {
    const { t, updateStatus, sendActionToBitacora } = this.props;
    const response = await updateStatus({id: data.id, status: data.estatus, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: data.estatus === StatusConst.IS_ACTIVE ? 'desacEmpresa' : 'activaEmpresa',
        reason: `${data.nombre} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return true;
  };

  onEditCompany = (node) => {
    const { history } = this.props

    return history.push({pathname: '/company/edit', state: { ...node }})
  }


  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onEditCompany(node)}
      />
    </div>
  );

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  columnCountry = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(rowData.pais)}
    </>
  )

  statusCompany = (node, detail) => {
    const { t } = this.props

    if (node.estatus === StatusConst.IS_ACTIVE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="link" onClick={() => this.onConfirmChangeStatus(node)}>{t('Activo')}</span>
        </>
      )
    }
    if (node.estatus === StatusConst.IS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red cursor-pointer" onClick={() => this.onConfirmChangeStatus(node)}> {t('SUSPENDIDA')} </span>
        </>
      );
    }
    return ''
  }

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  render() {
    const { t, history, countriesCurrentCatalog, validatePermissionAction } = this.props;
    const { loadingPage, business, loadingTable, findText, lazyParams, totalRecords, typeCountry, showModalJustification } = this.state;
    if (loadingPage) return true

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.CREAR_EMPRESA) && (
          <Button
            label={t('Agregar Empresa')}
            className="p-button-primary"
            onClick={() =>
              history.push('/company/new')
            }
          />
        )}
      </>
    );

    const headerTable = (
      <div className="p-grid">
        <div className="p-col-12 p-md-4 p-lg-4  p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('País')}:</label>
          <Dropdown
            name="typeCountry"
            value={typeCountry}
            options={countriesCurrentCatalog}
            onChange={this.onChange}
            optionLabel="label"
            filter
            showClear
            filterBy="label"
            placeholder=""
            style={{ width: '100%' }}
          />
        </div>
        <div className="p-col-12 p-md-6 p-lg-6 p-d-flex p-ai-center p-flex-column p-flex-sm-row p-jc-sm-center ">
          <div className="p-col p-d-flex p-ai-center is-full-width">
            <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
            <InputText
              name="findText"
              value={findText}
              onChange={this.onChange}
              className="p-mr-2 input-search-list"
            />
          </div>
          <div className="p-col is-full-width">
            <Button
              icon="pi pi-search"
              label={t('Buscar')}
              className="p-button-raised p-button-text p-button-plain btn-search-list"
              onClick={() => this.loadData()}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Empresas')} rightComponent={rightHeader} />
          <div className="card">
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={business}
                lazy
                paginator
                rows={lazyParams.rows}
                loading={loadingTable}
                totalRecords={totalRecords}
                first={lazyParams.first}
                onPage={this.onPage}
                header={headerTable}
                classNames="table-bussiness"
              >
                <Column
                  field="nombre"
                  header={t('Nombre')}
                  body={this.columnResponsive}
                  className="p-text-center-lg"
                />
                <Column
                  header={t('País')}
                  className="column-ten p-text-center-lg"
                  body={this.columnCountry}
                />
                <Column
                  header={t('Clave')}
                  field="clave"
                  body={this.columnResponsive}
                />
                <Column
                  header={t('Estatus')}
                  body={this.statusCompany}
                  className="column-status p-text-center-lg"
                />
                { validatePermissionAction(catalogPermissionsId.AJUSTAR_EMPRESA) && (
                  <Column
                    header={t('Editar')}
                    body={this.templateEdit}
                    className="column-action p-text-center-lg"
                  />
                )}
              </DataTable>
            </div>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
});

const mapDispatchToProps = {
  getBusiness,
  updateStatus,
  validatePermissionAction,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Business);
